import { Card } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { TrendingUp, PoundSterling, Activity } from 'lucide-react';

interface InsightsPanelProps {
  readonly width: number;
}

export function InsightsPanel({ width }: Readonly<InsightsPanelProps>) {
  return (
    <div 
      className="border-r bg-muted/30 flex flex-col overflow-hidden"
      style={{ width: `${width}px` }}
    >
      {/* Header */}
      <div className="h-14 border-b flex items-center px-4 flex-shrink-0 bg-background">
        <h2 className="font-semibold text-sm">Insights</h2>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <Card className="p-4 space-y-2">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-green-100 dark:bg-green-900/20 flex items-center justify-center">
              <TrendingUp className="h-4 w-4 text-green-600 dark:text-green-400" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">Total Movement</p>
              <p className="text-lg font-semibold">£2.4M</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground">
            +12% from last period
          </p>
        </Card>

        <Card className="p-4 space-y-2">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center">
              <Activity className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">Transactions</p>
              <p className="text-lg font-semibold">1,247</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground">
            Across all asset types
          </p>
        </Card>

        <Card className="p-4 space-y-2">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-orange-100 dark:bg-orange-900/20 flex items-center justify-center">
              <PoundSterling className="h-4 w-4 text-orange-600 dark:text-orange-400" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">Avg Transaction</p>
              <p className="text-lg font-semibold">£1,925</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground">
            Per transaction value
          </p>
        </Card>

        <Separator />

        <div className="space-y-2">
          <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
            Quick Stats
          </p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Additions</span>
              <span className="font-medium">342</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Depreciation</span>
              <span className="font-medium">567</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Disposals</span>
              <span className="font-medium">89</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Transfers</span>
              <span className="font-medium">124</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Revaluations</span>
              <span className="font-medium">125</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
